import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=67608df2&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=ts"
export * from "./PageHeader.vue?vue&type=script&lang=ts"
import style0 from "./PageHeader.vue?vue&type=style&index=0&id=67608df2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67608df2",
  null
  
)

export default component.exports